import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowTrendingDownIcon, ArrowTrendingUpIcon, CheckCircleIcon } from '@heroicons/react/24/outline'
import { ocenaZakresu } from '../../lib/cenyZOfert'
import { zl } from '../../lib/rynek'

/**
 * Zakres ceny zlecenia wobec prawdziwych ofert (prośba właściciela 2026-11-02). Skala odwrotna niż w ogłoszeniach dla
 * kupujących: firmie zależy na wyższej cenie, więc „powyżej” jest na zielono, a „poniżej” na czerwono. Znaczenie niesie
 * też ikona i napis, nie sam kolor. `zOpisem`: na stronie zlecenia dodatkowo liczby i link do artykułu ze źródłem.
 */
const POZIOMY = {
  powyzej: { Ikona: ArrowTrendingUpIcon, kolor: 'text-emerald-700', nazwa: 'Powyżej typowych ofert' },
  typowo: { Ikona: CheckCircleIcon, kolor: 'text-blue-700', nazwa: 'W typowym zakresie' },
  ponizej: { Ikona: ArrowTrendingDownIcon, kolor: 'text-red-700', nazwa: 'Poniżej typowych ofert' },
}
const ARTYKUL = '/baza-wiedzy/fotowoltaika-2027-ile-zaplacisz-ceny-z-ofert'

const OcenaCeny = ({ o, zakres, zOpisem = false, className = '' }) => {
  const ocena = ocenaZakresu(o, zakres)
  if (!ocena) return null
  const { Ikona, kolor, nazwa } = POZIOMY[ocena.poziom]
  const liczby = `Połowa podobnych ofert: ${Math.round(ocena.od).toLocaleString('pl-PL')} do ${zl(ocena.do)}`
  return (
    <span className={`inline-flex flex-wrap items-center gap-x-1.5 gap-y-0.5 ${className}`} title={zOpisem ? undefined : liczby}>
      <span className={`inline-flex items-center gap-1 font-semibold ${kolor}`}>
        <Ikona className="h-4 w-4 flex-none" strokeWidth={2.2} aria-hidden="true" />{nazwa}
      </span>
      {zOpisem && (
        <span className="text-gray-600">
          {liczby} (<Link to={ARTYKUL} className="font-semibold text-blue-700 hover:underline">skąd te dane</Link>).
        </span>
      )}
    </span>
  )
}

export default OcenaCeny
